(function () {

    'use strict';

    angular.module('stacktrace', [])
        .provider('stacktrace', StacktraceProvider);

    StacktraceProvider.$inject = [
        '$windowProvider'
    ];
    function StacktraceProvider($windowProvider) {
        var $window = $windowProvider.$get();

        return {
            $get: function () {
                return $window.StackTrace || {};
            }
        };
    }
})();
